
import { supabase } from '@/integrations/supabase/client';
import { CoachModel } from './types';
import { getUserGymId } from '@/utils/gymAuth';

export const getAllCoaches = async (): Promise<CoachModel[]> => {
  try {
    const gymId = getUserGymId();
    if (!gymId) {
      console.error('No gym selected');
      return [];
    }

    const { data, error } = await supabase.functions.invoke('coaches-management', {
      body: { 
        action: 'get_coaches',
        gym_id: gymId
      }
    });

    if (error) throw error;
    return data.coaches || [];
  } catch (error) {
    console.error('Error in getAllCoaches:', error);
    return [];
  }
};

export const getCoachById = async (id: string): Promise<CoachModel | null> => {
  try {
    const gymId = getUserGymId();
    if (!gymId) {
      console.error('No gym selected');
      return null;
    }

    const { data, error } = await supabase.functions.invoke('coaches-management', {
      body: { 
        action: 'get_coach', 
        params: { id },
        gym_id: gymId
      }
    });

    if (error) throw error;
    return data.coach || null;
  } catch (error) {
    console.error('Error in getCoachById:', error);
    return null;
  }
};

export const getCategories = async (): Promise<any[]> => {
  try {
    const gymId = getUserGymId();
    if (!gymId) {
      console.error('No gym selected');
      return [];
    }

    const { data, error } = await supabase.functions.invoke('coaches-management', {
      body: { 
        action: 'get_categories',
        gym_id: gymId
      }
    });

    if (error) throw error;
    return data.categories || [];
  } catch (error) {
    console.error('Error in getCategories:', error);
    return [];
  }
};
